import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IDevicesData {
  serialNo: string;
  gatewayStatus: string | null;
  plcStatus: string | null;
  iotTagVersion: string | null;
  plcVersion: string | null;
  deviceName: string | null;
  simNumber: string | null;
  CustomerName: string | null;
  dataLastReported: string | null;
  AssestsID: string | null;
  AssetId: string | null;
  ContainerVersions: string | null;
  DeviceModules: any[];
  IsSimActive: string | null;
  MachineID: string | null;
  PLCLastChanged: string | null;
  PlcLastReported: string | null;
  SWDeployementSatus: string | null;
  SimStatus: string | null;
  SleFWVersion: string | null;
  SoftwareDeploymentStatus: string | null | boolean;
  DeviceLatitude: string | null;
  DeviceLongitude: string | null;
}

interface DevicesDataState {
  devices: IDevicesData[];
  selectedCustomer: string | null;
}

const initialState: DevicesDataState = {
  devices: [],
  selectedCustomer: null,
};

const DevicesData = createSlice({
  name: "Devices",
  initialState,
  reducers: {
    setDevicesData: (state: any, action: PayloadAction<any>) => {
      state.devices = action.payload;
    },
    SelectedCustomer: (state, action: PayloadAction<string | null>) => {
      state.selectedCustomer = action.payload;
    },
  },
});

export const { setDevicesData, SelectedCustomer } = DevicesData.actions;
export default DevicesData;
